import { FullValidationErrorFragment } from '@common/graphql/fragments';
import { gql, TypedDocumentNode } from '@common/hooks';
import {
  BulkDeactivateWorkersMutationCgResponse,
  BulkDeactivateWorkersMutationVariables,
  BulkUpdateWorkersWorkforceGroupMutationCgResponse,
  BulkUpdateWorkersWorkforceGroupMutationVariables,
} from '@common/graphql/schema';

export const BULK_DEACTIVATE_WORKERS_MUTATION: TypedDocumentNode<
  BulkDeactivateWorkersMutationCgResponse,
  BulkDeactivateWorkersMutationVariables
> = gql`
  mutation BulkDeactivateWorkers($workerIds: [ID!]!) {
    bulkDeactivateWorkers(workerIds: $workerIds) {
      workers {
        id
        active
        worksUser {
          id
          firstName
          lastName
        }
      }
      errors {
        ...FullValidationErrorFragment
      }
    }
  }
  ${FullValidationErrorFragment}
`;

export const BULK_UPDATE_WORKERS_WORKFORCE_GROUP_MUTATION: TypedDocumentNode<
  BulkUpdateWorkersWorkforceGroupMutationCgResponse,
  BulkUpdateWorkersWorkforceGroupMutationVariables
> = gql`
  mutation BulkUpdateWorkersWorkforceGroup(
    $workerIds: [ID!]!
    $workforceGroupId: ID!
    $acknowledgeOverride: Boolean
  ) {
    bulkUpdateWorkersWorkforceGroup(
      workerIds: $workerIds
      workforceGroupId: $workforceGroupId
      acknowledgeOverride: $acknowledgeOverride
    ) {
      mappingConflicts {
        suggestedWorkforceGroup {
          id
          name
        }
        worker {
          id
        }
      }
      workers {
        id
        active
        workforceGroup {
          id
          name
        }
      }
      errors {
        ...FullValidationErrorFragment
      }
    }
  }
  ${FullValidationErrorFragment}
`;
